import * as React from 'react';

import {ActionMenu} from 'shells/action-menu/action-menu';
import {EditIcon, ArchiveIcon} from 'shells/icon';

type Props = {
    isForArchivedProducts: boolean;
    onEditProduct: () => void;
    onDeleteProduct: () => void;
    onUndeleteProduct: () => void;
};

export function ProductRowActionMenu(props: Props) {
    const unarchiveRowAction = {
        label: 'Unarchive',
        handleSelect: props.onUndeleteProduct,
        icon: <ArchiveIcon size={16} />,
    } as const;

    const archiveRowAction = {
        label: 'Archive',
        handleSelect: props.onDeleteProduct,
        icon: <ArchiveIcon size={16} />,
    } as const;

    const editRowAction = {
        label: 'Edit',
        handleSelect: props.onEditProduct,
        icon: <EditIcon size={16} />,
    } as const;

    function buildRowActionOptions() {
        if (props.isForArchivedProducts) {
            return [unarchiveRowAction];
        }

        return [editRowAction, archiveRowAction];
    }

    return <ActionMenu options={buildRowActionOptions()} size='small' hasHoverBackground={true} />;
}
